export const specialUserTypeOptions = [
  { text: 'Primary Attorney', value: 'primary_attorney' },
  { text: 'Primary Legal Assistant', value: 'primary_legal_assistant' },
  { text: 'Other Attorneys', value: 'other_attorneys' },
  { text: 'Other Legal Assistants', value: 'other_legal_assistants' },
]

export const permissionRoleOptions = [
  { text: 'All Admins', value: 'all_admins' },
  { text: 'All Editors', value: 'all_editors' },
  { text: 'All Contributors', value: 'all_contributors' },
]
